export interface SeguimientoDTO {
    idAnuncio: number,
    idSecuencia: number,
    idGestor: number,
    txObservacion?: string,
    bdEstado: string,
    dtSeguimiento: Date,
    bdEstadoRegistro: boolean
}

export function GetVoidSeguimientoDTO(): SeguimientoDTO {
    return {
        idAnuncio: 0,
        idSecuencia: 0,
        idGestor: 0,
        txObservacion: '',
        bdEstado: '',
        dtSeguimiento: new Date(),
        bdEstadoRegistro: false
    }
}